// Created common UI to be registered and work across app without to be imported.
import Vue from "vue";

import PageTitle from "./page-title/index.vue";
export { PageTitle as PageTitle };

import Block from "./block";
export { Block as Block };

import BlockGroup from "./block-group";
export { BlockGroup as BlockGroup };

import InputBox from "./forms/input-box/index.vue";
export { InputBox as InputBox };

import TextArea from "./forms/textarea/index.vue";
export { TextArea as TextArea };

import SelectBox from "./forms/select-box/index.vue";
export { SelectBox as SelectBox };

import RadioBox from "./forms/radio-box/index.vue";
export { RadioBox as RadioBox };

import CheckBox from "./forms/check-box/index.vue";
export { CheckBox as CheckBox };

import SearchBox from "./forms/search-box/index.vue";
export { SearchBox as SearchBox };

// export { default as Block } from "./block";

Vue.component('Block', Block);
Vue.component('BlockGroup', BlockGroup);
Vue.component('InputBox', InputBox);
Vue.component('TextArea', TextArea);
Vue.component('SelectBox', SelectBox);
Vue.component('RadioBox', RadioBox);
Vue.component('CheckBox', CheckBox);
Vue.component('SearchBox', SearchBox);
Vue.component('ui-page-title', PageTitle);
Vue.component('PageTitle', PageTitle);
